import { useEffect, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';

import type { ClientFormValues } from '../types/client-form';

interface IProps {
  submitRequest: (values: ClientFormValues) => Promise<string>;
  handleNext: () => void;
}

const useClientForm = ({ submitRequest, handleNext }: IProps) => {
  const methods = useForm<ClientFormValues, unknown>({
    mode: 'all',
    delayError: 200
  });
  const values = useWatch({ control: methods.control });

  const [submitLoading, setSubmitLoading] = useState(false);
  const [clientError, setClientError] = useState('');

  useEffect(() => {
    // Сбрасываем ошибку при изменении полей
    if (clientError) {
      setClientError('');
    }
  }, [values]);

  const handleClientFormSubmit = async (values: ClientFormValues) => {
    setSubmitLoading(true);
    const responseError = await submitRequest(values);
    if (!responseError) {
      handleNext();
    } else {
      setClientError(responseError);
    }
    setSubmitLoading(false);
  };

  return {
    clientFormMethods: methods,
    clientFormLoading: submitLoading,
    clientError,
    handleClientFormSubmit
  };
};

export default useClientForm;
